import React, { useState, useContext, useRef, useEffect } from 'react';
import { isNumber, isArray } from 'lodash';
import { Tooltip } from 'react-tippy';
import { CVBuilderContext } from './context';
import { cvActions } from '../../_global/js/_api';
import { AddEditItem } from './form';
import { CVLoader } from "../../loader/js/global";
import { PrintExperienceBlock, PrintAchievementBlock, PrintEducationBlock, PrintTags, PrintListItems, PrintRefereesBlock, PrintPortfolioBlock} from './templates';
import { bannerQuestions, skillsQuestions, qualificationsQuestions, awardsQuestions, experienceQuestions, employmentQuestions, educationQuestions, workExperienceQuestions, volunteeringQuestions, refereeQuestions, portfolioQuestions, extraCurricularQuestions } from './data';
import generateWordResume from './generateWordResume.js'

export const CVBuilder = ({ matrixUserData }) => {
    const { state, dispatch } = useContext(CVBuilderContext);
    const { userProfile } = state;
    const [showForm, setShowForm] = useState(false);
    const [showOverlay, setShowOverlay] = useState(false);
    const [showRemoveButton, setShowRemoveButton] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [item, setItem] = useState();
    const onLoad = useRef();

    useEffect(() => {
        
        const timer = setTimeout(() => {
            cvActions({type: "get"}).then((data)=> {
                if(data) {
                    // console.log(data);
                    dispatch({
                        type: 'get',
                        data
                    });
                }            
            })
        }, 150);

        return () => clearTimeout(timer);
    }, [onLoad]);

    useEffect(() => {
        if(showOverlay){
            const editForm = document.querySelector('.add-edit__form');
            editForm.querySelectorAll('input')[0].focus();
        }
    }, [showOverlay]);

    const handleHideForm = () => {
        setShowForm(false);
        setShowOverlay(false);
        setItem();
    }

    const handleAddOrEditForm = (props) => {
        const {field, index, type} = props;
        // FIX THIS WEIRD LOGIC
        let editItemInfo = isNumber(index) ? state[field][index] : state[field];
        // console.log(type,editItemInfo)
        if(isArray(editItemInfo)) {
            editItemInfo = null;
        }

        setShowOverlay(true);
        setItem({...props, info: editItemInfo});
        setShowForm(true);
    }

    const handleShowRemoveButton = () => {
        setShowRemoveButton(true);
    }

    const handleSubmitForm = (data) => {
        setShowLoader(true);
        const { type, info, field } = item;
        const editIdOrNew = info ? info.id : null;
        const action = data.remove ? 'remove' : type;
        const submissionData = {
            id: editIdOrNew,
            field,
            data,
            type: action
        }
        // console.log(item);
        // console.log(submissionData);
        cvActions(submissionData).then((response) => {
            // console.log(response);
            const itemObject = action === 'remove' ? data : response;
            dispatch({
                id: editIdOrNew,
                type: action,
                field,
                item: itemObject
            });
            setShowLoader(false);
            setShowForm(false);
            setShowOverlay(false);
            setShowRemoveButton(false);
        });
    }

    // console.log(state);

    if(userProfile) {
        return (
            <>
                <div className="cv-builder__block cv-builder__header">
                    <div className="cv-builder__header-container">
                        <div className="cv-builder__header-info">
                            <h2 className="cv-builder__block-heading">{userProfile.name}</h2>
                            <i className="fas fa-user cv-builder__avatar"></i>
                            <p className="cv-builder__profile-short">{userProfile.shortIntro || 'Add a short intro by clicking the edit button'}</p>
                        </div>

                        <div className="action__button">
                            <button 
                                className="cv-builder__export"
                                onClick={()=>{
                                    generateWordResume(state)
                                }}
                            ><i className="fas fa-upload"></i>Export to word document</button>
                            <button 
                                className="button--normal cv-builder__section-edit"
                                onClick={() => handleAddOrEditForm({
                                    type: 'update',
                                    field: 'userProfile', 
                                    index: null, 
                                    title: 'details',
                                    questions: bannerQuestions
                                })}
                                type="button"
                            >
                                <i className="far fa-edit"></i>
                                <span className="sr-only">Edit details</span>
                            </button>
                        </div>

                        <h3 className="cv-builder__block-subheading">Personal qualities</h3>
                        <p className="cv-builder__profile-long">{userProfile.longIntro || 'Add a description about yourself intro by clicking the edit button'}</p>
                        {userProfile.qualitiesList && userProfile.qualitiesList.length > 0 ? 
                            <PrintTags tagsList={userProfile.qualitiesList} />
                            : 
                            <p>No qualities added yet. Add some by clicking the edit button!</p>
                        }
                    </div>
                </div>

                <div className="cv-builder__row">
                    <div className="cv-builder__left">
                        <div className="cv-builder__block">
                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">Qualifications &amp; Licences</h2>
                                {state.qualifications.length > 0 ?
                                <PrintAchievementBlock
                                    achievements={state.qualifications} 
                                    editAction={handleAddOrEditForm} 
                                    field="qualifications"
                                    title="qualification or licence" 
                                    questions={qualificationsQuestions}
                                    />
                                : <p className="cv-builder__list-none">No qualifications or licences added yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'qualifications', 
                                            index: null, 
                                            title: 'qualification or licence',
                                            preset: {achieveType: ['Qualification']},
                                            questions: qualificationsQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>
                            

                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">Awards</h2>
                                {state.awards.length > 0 ?
                                <PrintAchievementBlock
                                    achievements={state.awards} 
                                    editAction={handleAddOrEditForm} 
                                    field="awards"
                                    title="award" 
                                    questions={awardsQuestions}
                                    wowData={[
                                        matrixUserData,
                                        state.wowchallenge,
                                        state.userProfile
                                    ]}
                                    />
                                : <p className="cv-builder__list-none">No awards added yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'awards', 
                                            index: null, 
                                            title: 'award',
                                            preset: {achieveType: ['Award']},
                                            questions: awardsQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="cv-builder__block-container cv-builder__skills">
                                <h2 className="cv-builder__block-heading">Skills</h2>
                                
                                {userProfile.skillsList && userProfile.skillsList.length > 0 ? 
                                    <PrintTags tagsList={userProfile.skillsList} />
                                    : 
                                    <p>No skills added yet. Add some!</p>
                                }
                                
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__section-edit"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'update',
                                            field: 'userProfile',
                                            index: null, 
                                            title: 'skills',
                                            questions: skillsQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="far fa-edit"></i>
                                        <span className="sr-only">Edit skills</span>
                                    </button>
                                </div>
                            </div>

                            {/* <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">Referees</h2>
                                
                                {state.referees && state.referees.length > 0 ? 
                                    <PrintRefereesBlock 
                                        referees={state.referees} 
                                        editAction={handleAddOrEditForm} 
                                        field="referees"
                                        title="referee" 
                                        questions={refereeQuestions}
                                    />
                                    : 
                                    <p>No referees. Add a referee to verify your character and abilities</p>
                                }
                                
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'referees', 
                                            index: null, 
                                            title: 'referee',
                                            preset: {supType: ['Referee']},
                                            questions: refereeQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div> */}


                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">Portfolio</h2>
                                
                                {state.portfolio && state.portfolio.length > 0 ? 
                                    <PrintPortfolioBlock 
                                        portfolio={state.portfolio} 
                                        editAction={handleAddOrEditForm} 
                                        field="portfolio"
                                        title="link" 
                                        questions={portfolioQuestions}
                                    />
                                    : 
                                    <p>No portfolio work listed yet. Add some to show off your work!</p>
                                }
                                
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'portfolio', 
                                            index: null, 
                                            title: 'link',
                                            preset: {supType: ['Portfolio']},
                                            questions: portfolioQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>
                            
                        </div>                    
                    </div>

                    <div className="cv-builder__right">
                        <div className="cv-builder__block">
                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">
                                    Education
                                </h2>
                                {state.educationCerts.length > 0 ?
                                <PrintEducationBlock 
                                    education={state.educationCerts} 
                                    editAction={handleAddOrEditForm} 
                                    field="educationCerts"
                                    title="studies" 
                                    questions={educationQuestions}
                                    />
                                : <p className="cv-builder__list-none">I&apos;ve not had any experiences out of school yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'educationCerts', 
                                            index: null, 
                                            title: 'education history',
                                            questions: educationQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">
                                    Employment
                                </h2>
                                {state.employmentExp.length > 0 ?
                                <PrintExperienceBlock 
                                    experiences={state.employmentExp} 
                                    editAction={handleAddOrEditForm} 
                                    field="employmentExp"
                                    title="employment" 
                                    questions={employmentQuestions}
                                    />
                                : <p className="cv-builder__list-none">I&apos;ve not had employment out of school yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'employmentExp', 
                                            index: null, 
                                            title: 'employment',
                                            preset: {expType: ['Employment']},
                                            questions: employmentQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">
                                    Work Experience
                                </h2>
                                {state.workExp.length > 0 ?
                                <PrintExperienceBlock 
                                    experiences={state.workExp} 
                                    editAction={handleAddOrEditForm} 
                                    field="workExp"
                                    title="work experience" 
                                    questions={workExperienceQuestions}
                                    />
                                : <p className="cv-builder__list-none">I&apos;ve not had any work experience out of school yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'workExp', 
                                            index: null, 
                                            title: 'work experience',
                                            preset: {expType: ['Work experience']},
                                            questions: workExperienceQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="cv-builder__block-container">
                                <h2 className="cv-builder__block-heading">
                                    Volunteering Experience
                                </h2>
                                {state.volunteeringExp.length > 0 ?
                                <PrintExperienceBlock 
                                    experiences={state.volunteeringExp} 
                                    editAction={handleAddOrEditForm} 
                                    field="volunteeringExp"
                                    title="volunteering experience" 
                                    questions={volunteeringQuestions}
                                    />
                                : <p className="cv-builder__list-none">I&apos;ve not had any voluntering experience out of school yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__button-add"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'add',
                                            field: 'volunteeringExp', 
                                            index: null, 
                                            title: 'volunteering experience',
                                            preset: {expType: ['Volunteering']},
                                            questions: volunteeringQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="fas fa-plus"></i>
                                        Add
                                    </button>
                                </div>
                            </div>

                            <div className="cv-builder__block-container cv-builder__extrac">
                                <h2 className="cv-builder__block-heading">
                                    Extra-curricular activities
                                    <Tooltip 
                                        className="tooltip__container"
                                        title="eg languages you speak, groups you belong to" 
                                        position="top"
                                        tabIndex="0"
                                        > 
                                        <div className="tooltip__icon">
                                            <i className="fas fa-info" />
                                        </div>
                                    </Tooltip>
                                </h2>
                                {userProfile.extraCurricularList && userProfile.extraCurricularList.length > 0 ?
                                <PrintListItems listItems={userProfile.extraCurricularList} />
                                : <p className="cv-builder__list-none">I&apos;ve not had any extra-curricular experience out of school yet.</p>}
                                <div className="action__button">
                                    <button 
                                        className="button--normal cv-builder__section-edit"
                                        onClick={() => handleAddOrEditForm({
                                            type: 'update',
                                            field: 'userProfile',
                                            index: null, 
                                            title: 'extra-curricular activities',
                                            questions: extraCurricularQuestions
                                        })}
                                        type="button"
                                    >
                                        <i className="far fa-edit"></i>
                                        <span className="sr-only">Edit extra-curricular activities</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {
                    showOverlay ? (
                        <div id="add-edit" className="add-edit__wrapper">
                            <div className="screen-overlay" onClick={handleHideForm} />
                            
                            <div className="add-edit__container">
                                <button
                                    className="add-edit__close toggle__close"
                                    type="button"
                                    aria-controls="add-edit"
                                    aria-expanded="true"
                                    aria-label="Toggle add/edit work experience"
                                    onClick={handleHideForm}
                                >
                                    <span className="toggle__close-text">
                                        Close
                                    </span>
                                    <i className="fas fa-times"></i>
                                </button>
                                
                                {showForm ? (
                                    <AddEditItem item={item} closeForm={handleHideForm} submitForm={handleSubmitForm} showRemoveButton={handleShowRemoveButton} />
                                ) : null}

                            </div>
                            
                            {showRemoveButton ? (
                                <>
                                    <div className="screen-overlay" onClick={() => setShowRemoveButton(false)} />
                                    <div className="remove-button__container">
                                        <div className="action__button">
                                            <p>Are you sure you want to remove?</p>
                                            <button 
                                                type="button" 
                                                className="button--submit" 
                                                onClick={() => setShowRemoveButton(false)}
                                                >
                                                Cancel
                                            </button>
                                            <button 
                                                type="submit" 
                                                className="button--submit add-edit__form-remove" 
                                                onClick={() => handleSubmitForm({remove: true})}
                                                >
                                                Yes
                                            </button>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                            
                            {showLoader ? <div className="loading" /> : null}
                        </div>
                    ) :
                    null
                }
            </>
            
        )
    }
    else {
        return <CVLoader />
    }
    
}
